import { Button, CircularProgress, InputAdornment, TextField } from "@material-ui/core";
import BasicModal from "components/BasicModal";
import {
    cancelLabel,
    estimateFields,
    estimateModalHeader,
    workRequestButtonLabels
} from "features/workRequest/workRequestConsts";
import { useEffect, useState } from "react";
import { sendEstimateModalStyles } from "./SendEstimateModalStyles";

const emptyAmounts = Object.fromEntries(estimateFields.map(field => [field.id, '']));

const isValidAmount = (value) => value === '' || (!isNaN(Number(value)) && Number(value) >= 0);

const SendEstimateModal = ({ open, onClose, onSend, isSending }) => {
    const classes = sendEstimateModalStyles();

    const [amounts, setAmounts] = useState(emptyAmounts);

    useEffect(() => {
        if (open) setAmounts(emptyAmounts);
    }, [open]);

    const onAmountChange = (id, value) => setAmounts(prev => ({ ...prev, [id]: value }));

    const hasAmount = estimateFields.some(field => amounts[field.id] !== '');
    const allValid = estimateFields.every(field => isValidAmount(amounts[field.id]));

    const onSubmit = () =>
        onSend(Object.fromEntries(estimateFields.map(field => [field.id, Number(amounts[field.id] || 0)])));

    const content = (
        <div className={classes.content}>
            <div className={classes.fields}>
                {estimateFields.map(field => (
                    <TextField
                        key={field.id}
                        label={field.label}
                        type="number"
                        variant="outlined"
                        value={amounts[field.id]}
                        error={!isValidAmount(amounts[field.id])}
                        onChange={(event) => onAmountChange(field.id, event.target.value)}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>
                        }}
                        inputProps={{ min: 0, step: '0.01' }}
                    />
                ))}
            </div>

            <div className={classes.actions}>
                <Button variant="outlined" onClick={onClose} disabled={isSending}>
                    {cancelLabel}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!hasAmount || !allValid || isSending}
                    onClick={onSubmit}
                    startIcon={isSending ? <CircularProgress size={14} /> : undefined}
                >
                    {workRequestButtonLabels.SEND_ESTIMATE}
                </Button>
            </div>
        </div>
    );

    return (
        <BasicModal
            open={open}
            header={estimateModalHeader}
            handleClose={onClose}
            component={content}
        />
    );
};

export default SendEstimateModal;
